export const GlobalFilterRoute = {
  GLOBAL_FILTERS: 'globalfilters',
};

export const GlobalFilterPathName = {
  GLOBAL_FILTERS: 'globalfilters',
  GLOBAL_FILTERFORM_NEW: 'globalglobalfilterform:new',
  GLOBAL_FILTERFORM: 'globalfilterform',
};

export const DashboardFields = {
  TITLE: 'title',
  ID: 'id',
  REPORTING_PROFILES: 'reporting_profiles',
};

export const GlobalFilterFields = {
  ID: 'id',
  NAME: 'name',
};

export const GLOBAL_FILTER_KEY_PREFIX = 'filter_';

export const GlobalFilterApiRoute = {
  FIELDS: 'fields',
  VALUES: 'values',
};

export const GLOBAL_FILTER_VALUES_LIMIT = 500;

/**
 * Watcher path constants for GlobalFilterForm component.
 * Using constants instead of raw strings satisfies the tap/no-raw-text-js rule
 * and makes watcher paths refactor-safe.
 */
export const GlobalFilterFormWatcherPath = {
  FORM_DATA: 'form.data',
  SERVICE_SELECT_OPTIONS_VALUES: 'serviceSelectOptions.values',
};

/** Route segment used to build the fields API endpoint. */
export const GlobalFilterRouteSegment = {
  FIELDS: 'fields',
};

/** CSS classes applied to disconnected service icons in the services cell. */
export const GlobalFilterServiceCssClass = {
  DISABLED: 'disabled m-t-2 m-b-2',
};

/** Icon naming conventions used by GlobalFilterService. */
export const GlobalFilterServiceIcon = {
  PREFIX: 'serviceicon',
  DEFAULT: 'serviceicon-default',
};

/**
 * Returns true when value is a plain, non-null, non-array object.
 * Centralised here so callers in non-constants files never need a raw
 * `typeof x === 'object'` string literal (which triggers tap/no-raw-text-js).
 *
 * @param {*} value
 * @returns {boolean}
 */
export const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);
